export enum PaymentMethodTypeIdEnum {
  Cash = 1,
  Cheque = 2,
  CreditCard = 3,
  Bank = 4,
  Payline = 5
}
